import React, { useState, useEffect } from 'react';
import './BlogSection.css';
import blogData from '../../data/blog-posts.json';

const BlogSection = () => {
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    // Try to fetch from Netlify function first (for production)
    const fetchBlogPosts = async () => {
      try {
        const response = await fetch('/.netlify/functions/fetch-blogs');
        if (response.ok) {
          const data = await response.json();
          setBlogPosts(data.posts || []);
        } else {
          // Fallback to local JSON file
          setBlogPosts(blogData.posts);
        }
      } catch (error) {
        // If fetch fails (local development), use local JSON file
        console.log('Using local blog data');
        setBlogPosts(blogData.posts);
      }
    };

    fetchBlogPosts();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <section id="blog" className="blog-section section">
      <div className="section-container">
        <h2 className="section-heading-main">Blogs</h2>
      
        <div className="blog-intro">
          <p className="blog-description">
            Writing on <strong>Data Pe Charcha</strong> about data science, machine learning, and AI.
          </p>
        </div>

        <div className="blog-grid">
          {blogPosts.length > 0 ? (
            blogPosts.map(post => (
              <a href={post.link} className="blog-card-link" key={post.id} target="_blank" rel="noopener noreferrer">
                <article className="blog-card">
                  <div className="blog-card-header">
                    <time className="blog-date">{formatDate(post.date)}</time>
                  </div>
                  
                  <h3 className="blog-title">{post.title}</h3>
                  <p className="blog-excerpt">{post.excerpt}</p>
                  
                  <div className="blog-card-footer">
                    <span className="read-more">
                      Read More →
                    </span>
                  </div>
                </article>
              </a>
            ))
          ) : (
            <p className="blog-loading">Loading posts...</p>
          )}
        </div>
        
        <div className="blog-footer">
          <a href="https://datapecharcha.substack.com/" className="btn" target="_blank" rel="noopener noreferrer">
            View all posts →
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
